import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { isAddress } from "ethers";
import noZoom from "./assets/js/noZoom";
import cookie from "js-cookie";
import ChangeLanguageButton from "@components/ChangeLanguageButton.vue";
const walletVuex = createNamespacedHelpers("wallet");
noZoom();
export default {
  components: {
    ChangeLanguageButton
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    ...walletVuex.mapState(["setting", "isMobile", "connect", "address", "isLang"]),
    route() {
      showScreen;
      return this.$route.path;
    }
  },
  watch: {
    connect: {
      async handler(val) {},
      immediate: true
    },
    isLang: {
      async handler(val) {
        this.mTab = [{
          label: this.$lang("HOME"),
          value: "official"
        }, {
          label: this.$lang("NODE"),
          value: "/"
        }, {
          label: this.$lang("DOC"),
          value: "doc"
        }];
      },
      immediate: true
    }
  },
  data() {
    return {
      isLoading: false,
      isRouterAlive: true,
      menuShow: false,
      mTab: [{
        label: this.$lang("HOME"),
        value: "official"
      }, {
        label: this.$lang("NODE"),
        value: "/"
      }, {
        label: this.$lang("DOC"),
        value: "doc"
      }]
    };
  },
  methods: {
    ...walletVuex.mapActions(["doConnect", "doDisconnect"]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    onTab(item) {
      this.menuShow = false;
      if (item.value == 'official') {
        window.open('https://reflectionai.app/');
        return;
      } else if (item.value == 'doc') {
        window.open('https://docs.reflectionai.app/');
        return;
      } else this.$router.push(item.value);
    },
    //邀请码
    setInvite() {
      const route = this.$route;
      const query = route.query;
      const path = route.path;
      const invite = cookie.get("t");
      console.log(path, invite, query);
      console.log("invite: ", invite);
      if (query?.t && isAddress(query?.t)) {
        cookie.set("t", query.t);
        localStorage.setItem("t", query.t);
      }
    },
    onSkip(t) {
      this.menuShow = false;
      let targetUri = "";
      switch (t) {
        case "twitter":
          targetUri = "https://x.com/reflectionai_";
          break;
        case "telegram":
          targetUri = "https://t.me/reflection_ai";
          break;
      }
      if (targetUri) window.open(targetUri);
    },
    disConnect() {
      this.doDisconnect();
    }
  },
  async created() {
    // console.log("this.web3Wallet", this.web3Wallet);
    this.web3Wallet && this.web3Wallet.initWeb3Modal();
    const walletConnected = localStorage.getItem("WALLET_CONNECTED");
    if (walletConnected == "true" || walletConnected == true) {
      await this.doConnect(true);
    }
  },
  mounted() {
    let timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      this.setInvite();
    }, 200);
  }
};